<template>
  <v-card width="320px" height="200px">
    <table>
      <tbody>
        <tr>
          <td>Latitude:</td>
          <td>{{ position.latitude }}</td>
        </tr>
        <tr>
          <td>Longitude:</td>
          <td>{{ position.longitude }}</td>
        </tr>
        <tr>
          <td>Accuracy:</td>
          <td>{{ position.accuracy.toFixed(3) }}m</td>
        </tr>
        <tr>
          <td>Altitude:</td>
          <td>{{ position.altitude }}</td>
        </tr>
        <tr>
          <td>Altitude Accuracy:</td>
          <td>{{ position.altitudeAccuracy }}</td>
        </tr>
        <tr>
          <td>Heading:</td>
          <td>{{ position.heading }}</td>
        </tr>
        <tr>
          <td>Speed:</td>
          <td>{{ position.speed }}</td>
        </tr>
      </tbody>
    </table>
  </v-card>
</template>

<script setup lang="ts">
const props = defineProps<{
  position: GeolocationCoordinates
}>()

const { position } = toRefs(props)
</script>
